import {
  LIBRARY_MODIFIER_PAGE_REQUEST,
  LIBRARY_MODIFIER_SET_OUTLETS,
  LIBRARY_MODIFIER_OUTLETS_REQUEST,
  LIBRARY_MODIFIER_ON_CHANGE_OUTLET_IDS,
  LIBRARY_MODIFIER_ON_CLICK_CREATE_MODIFIER,
  LIBRARY_MODIFIER_FILL_MODIFIER_FORM,
  LIBRARY_MODIFIER_SET_MODIFIERS,
  LIBRARY_MODIFIER_ON_CLICK_ROW,
  LIBRARY_MODIFIER_SET_MODIFIER_DETAIL,
  LIBRARY_MODIFIER_MODIFIERS_REQUEST,
  LIBRARY_MODIFIER_SET_CURRENT_PAGE,
  LIBRARY_MODIFIER_SET_TOTAL_PAGE,
  LIBRARY_MODIFIER_ON_CLICK_CANCEL,
  LIBRARY_MODIFIER_SUBMIT_FORM_CREATE,
  LIBRARY_MODIFIER_SUBMIT_FORM_UPDATE,
  LIBRARY_MODIFIER_DELETE_MODIFIER,
  LIBRARY_MODIFIER_CANCEL_DELETE_MODIFIER,
  LIBRARY_MODIFIER_SHOW_DELETE_MODIFIER_MODAL,
  LIBRARY_MODIFIER_HIDE_DELETE_MODIFIER_MODAL,
  LIBRARY_MODIFIER_SET_DELETED_MODIFIER,
  LIBRARY_MODIFIER_ASK_DELETE_MODIFIER,
  LIBRARY_MODIFIER_SUBMIT_FORM_CREATE_ALL_OUTLET,
  LIBRARY_MODIFIER_ON_CLICK_APPLY_SET_ITEM,
  LIBRARY_MODIFIER_SHOW_APPLY_SET_ITEM_MODAL,
  LIBRARY_MODIFIER_HIDE_APPLY_SET_ITEM_MODAL,
  LIBRARY_MODIFIER_CANCEL_APPLY_SET_ITEM,
  LIBRARY_MODIFIER_APPLY_SET_ITEM_SET_ITEMS,
  LIBRARY_MODIFIER_APPLY_SET_ITEM_SET_CURRENT_PAGE,
  LIBRARY_MODIFIER_APPLY_SET_ITEM_SET_TOTAL_PAGE,
  LIBRARY_MODIFIER_APPLY_SET_ITEM_FILL_FORM,
  LIBRARY_MODIFIER_APPLY_SET_ITEM_ITEMS_REQUEST,
  LIBRARY_MODIFIER_SHOW_MODIFIER_OPTIONS_MODAL,
  LIBRARY_MODIFIER_HIDE_MODIFIER_OPTIONS_MODAL,
  LIBRARY_MODIFIER_CONFIRM_APPLY_SET_ITEM,
  LIBRARY_MODIFIER_ON_CLICK_MANAGE_MODIFIER_OPTIONS,
  LIBRARY_MODIFIER_ON_CANCEL_MANAGE_MODIFIER_OPTIONS,
  LIBRARY_MODIFIER_ON_CONFIRM_MANAGE_MODIFIER_OPTIONS,
  LIBRARY_MODIFIER_SET_PREVIOUS_MODIFIER_FORM,
  LIBRARY_MODIFIER_EMPTY_MODIFIER_FORM,
  LIBRARY_MODIFIER_OPEN_RIGHT_COLUMN,
  LIBRARY_MODIFIER_CLOSE_RIGHT_COLUMN,
  LIBRARY_MODIFIER_IS_SUBMITTING_FORM
} from './constants'

export function pageRequest () {
  return {type: LIBRARY_MODIFIER_PAGE_REQUEST, payload: {}}
}

export function setOutlets (outlets) {
  return {type: LIBRARY_MODIFIER_SET_OUTLETS, payload: {outlets}}
}

export function outletsRequest (params) {
  return {type: LIBRARY_MODIFIER_OUTLETS_REQUEST, payload: {params}}
}

export function modifiersRequest (params, previousModifiers) {
  return {type: LIBRARY_MODIFIER_MODIFIERS_REQUEST, payload: {params, previousModifiers}}
}

export function onChangeOutletIds (outletIds) {
  return {type: LIBRARY_MODIFIER_ON_CHANGE_OUTLET_IDS, payload: {outletIds: outletIds}}
}

export function onClickCreateModifier () {
  return {type: LIBRARY_MODIFIER_ON_CLICK_CREATE_MODIFIER, payload: {}}
}

export function onClickRow (modifier) {
  return {type: LIBRARY_MODIFIER_ON_CLICK_ROW, payload: {modifier}}
}

export function onClickCancel () {
  return {type: LIBRARY_MODIFIER_ON_CLICK_CANCEL, payload: {}}
}

export function setModifiers (modifiers) {
  return {type: LIBRARY_MODIFIER_SET_MODIFIERS, payload: {modifiers}}
}

export function setModifierDetail (modifier) {
  return {type: LIBRARY_MODIFIER_SET_MODIFIER_DETAIL, payload: {modifier}}
}

export function setCurrentPage (currentPage) {
  return {type: LIBRARY_MODIFIER_SET_CURRENT_PAGE, payload: {currentPage}}
}

export function setTotalPage (totalPage) {
  return {type: LIBRARY_MODIFIER_SET_TOTAL_PAGE, payload: {totalPage}}
}

export function submitFormCreate (data, previousModifiers) {
  return {type: LIBRARY_MODIFIER_SUBMIT_FORM_CREATE, payload: {data, previousModifiers}}
}

export function submitFormCreateAllOutlet (data, previousModifiers) {
  return {type: LIBRARY_MODIFIER_SUBMIT_FORM_CREATE_ALL_OUTLET, payload: {data, previousModifiers}}
}

export function submitFormUpdate (modifierId, data, previousModifiers) {
  return {type: LIBRARY_MODIFIER_SUBMIT_FORM_UPDATE, payload: {modifierId, data, previousModifiers}}
}

export function deleteModifier (modifierId, previousModifiers) {
  return {type: LIBRARY_MODIFIER_DELETE_MODIFIER, payload: {modifierId, previousModifiers}}
}

export function cancelDeleteModifier () {
  return {type: LIBRARY_MODIFIER_CANCEL_DELETE_MODIFIER, payload: {}}
}

export function showDeleteModifierModal () {
  return {type: LIBRARY_MODIFIER_SHOW_DELETE_MODIFIER_MODAL, payload: {}}
}

export function hideDeleteModifierModal () {
  return {type: LIBRARY_MODIFIER_HIDE_DELETE_MODIFIER_MODAL, payload: {}}
}

export function setDeletedModifier (deletedModifier) {
  return {type: LIBRARY_MODIFIER_SET_DELETED_MODIFIER, payload: {deletedModifier}}
}

export function askDeleteModifier (deletedModifier) {
  return {type: LIBRARY_MODIFIER_ASK_DELETE_MODIFIER, payload: {deletedModifier}}
}

export function onClickApplySetItem (modifier) {
  return {type: LIBRARY_MODIFIER_ON_CLICK_APPLY_SET_ITEM, payload: {modifier}}
}

export function cancelApplySetItem () {
  return {type: LIBRARY_MODIFIER_CANCEL_APPLY_SET_ITEM, payload: {}}
}

export function confirmApplySetItem (data, modifierId) {
  return {type: LIBRARY_MODIFIER_CONFIRM_APPLY_SET_ITEM, payload: {data, modifierId}}
}

export function showApplySetItem () {
  return {type: LIBRARY_MODIFIER_SHOW_APPLY_SET_ITEM_MODAL, payload: {}}
}

export function hideApplySetItemModal () {
  return {type: LIBRARY_MODIFIER_HIDE_APPLY_SET_ITEM_MODAL, payload: {}}
}

export function applySetItemSetItems (items) {
  return {type: LIBRARY_MODIFIER_APPLY_SET_ITEM_SET_ITEMS, payload: {items}}
}

export function applySetItemFillForm (modifier) {
  return {type: LIBRARY_MODIFIER_APPLY_SET_ITEM_FILL_FORM, payload: {modifier}}
}

export function applySetItemSetCurrentPage (currentPage) {
  return {type: LIBRARY_MODIFIER_APPLY_SET_ITEM_SET_CURRENT_PAGE, payload: {currentPage}}
}

export function applySetItemSetTotalPage (totalPage) {
  return {type: LIBRARY_MODIFIER_APPLY_SET_ITEM_SET_TOTAL_PAGE, payload: {totalPage}}
}

export function applySetItemItemsRequest (params, previousItems) {
  return {type: LIBRARY_MODIFIER_APPLY_SET_ITEM_ITEMS_REQUEST, payload: {params, previousItems}}
}

export function fillModifierForm (modifier) {
  return {type: LIBRARY_MODIFIER_FILL_MODIFIER_FORM, payload: {modifier}}
}

export function emptyModifierForm () {
  return {type: LIBRARY_MODIFIER_EMPTY_MODIFIER_FORM, payload: {}}
}

export function showModifierOptionsModal () {
  return {type: LIBRARY_MODIFIER_SHOW_MODIFIER_OPTIONS_MODAL, payload: {}}
}

export function hideModifierOptionsModal () {
  return {type: LIBRARY_MODIFIER_HIDE_MODIFIER_OPTIONS_MODAL, payload: {}}
}

export function onClickManageModifierOptions (previousModifierForm) {
  return {type: LIBRARY_MODIFIER_ON_CLICK_MANAGE_MODIFIER_OPTIONS, payload: {previousModifierForm}}
}

export function onCancelManageModifierOptions (previousModifierForm) {
  return {type: LIBRARY_MODIFIER_ON_CANCEL_MANAGE_MODIFIER_OPTIONS, payload: {previousModifierForm}}
}

export function onConfirmManageModifierOptions (options) {
  return {type: LIBRARY_MODIFIER_ON_CONFIRM_MANAGE_MODIFIER_OPTIONS, payload: {options}}
}

export function setPreviousModifierForm (previousModifierForm) {
  return {type: LIBRARY_MODIFIER_SET_PREVIOUS_MODIFIER_FORM, payload: {previousModifierForm}}
}

export function openRightColumn () {
  return {type: LIBRARY_MODIFIER_OPEN_RIGHT_COLUMN, payload: {}}
}

export function closeRightColumn () {
  return {type: LIBRARY_MODIFIER_CLOSE_RIGHT_COLUMN, payload: {}}
}

export function isSubmittingForm (isSubmittingForm) {
  return {type: LIBRARY_MODIFIER_IS_SUBMITTING_FORM, payload: {isSubmittingForm}}
}



// WEBPACK FOOTER //
// ./app/actions/library/modifier/modifier.js